<template>
  <div>
    <v-combobox
      :value="registration"
      :filter="filter"
      :label="$t('addShooting.licencePlateCoverLabel')"
      :hide-no-data="!search"
      :items="registrationsFilter"
      :search-input.sync="search"
      hide-selected
      @input="changing"
    >
      <template v-slot:no-data>
        <v-list-item>
          <span class="subheading">{{ $t('addShooting.create') }} : {{ search }}</span>
        </v-list-item>
      </template>
      <template v-slot:selection="{ attrs, item }" @keydown="test">
        <span class="pr-2"> {{ item }}</span>
      </template>
      <template v-slot:item="{ item }">{{ item }}</template>
    </v-combobox>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'RegistrationSelect',
  props: {
    registrations: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      model: [],
      search: null
    }
  },
  computed: {
    ...mapState({
      registration: state => state.newShooting.registration
    }),
    registrationsFilter() {
      let items = [{ header: this.$t('addShooting.inputResearchLicenceText') }]
      this.registrations.forEach(el => items.push(el.registration))
      return items
    }
  },
  methods: {
    filter(item, queryText, itemText) {
      if (item.header) return false
      const hasValue = val => (val != null ? val : '')
      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return (
        text
          .toString()
          .toUpperCase()
          .indexOf(query.toString().toUpperCase()) > -1
      )
    },
    changing(val) {
      if (!val || val === '') {
        this.$store.commit('UPDATE_REGISTRATION', '')
        this.$store.commit('UPDATE_NEW_SHOOTING', [])
        this.$store.commit('UPDATE_STAMP', null)
        return
      }

      val = val.toUpperCase()

      let valExist =
        this.registrationsFilter
          .toString()
          .toUpperCase()
          .indexOf(val.toString()) > -1

      this.$store.commit('UPDATE_REGISTRATION', val)

      if (!valExist) {
        this.$store.commit('UPDATE_NEW_SHOOTING_STATUS', 'create')
      } else {
        this.$store.commit('UPDATE_OWNER', this.findOwnerWithImmat(val))
        this.$store.commit('UPDATE_NEW_SHOOTING_STATUS', 'modify')
      }
    },
    findOwnerWithImmat(immat) {
      const item = this.registrations.find(el => {
        return el.registration === immat
      })

      return item.ownerId
    }
  }
}
</script>

<style lang="sass" scoped>
p
  text-align: center
  font-size: 16px
  color: rgba(0, 0, 0, 0.7)
</style>
